import merge from "deepmerge";

export const blankKey = {
  sku: "my_project",
  storeGK: "not ready",
  keyData: {
    general: {
      sku: {
        value: "my_project",
        shown: false
      },
      name: {
        value: "My Project",
        languages: false,
        content: ["My Project", "Мой проект", "Mon projet"]
      }
    },
    buyPre: {
      value: "buy", //pre
      when: "exact"
    },
    delivery: {
      value: "xsolla"
    },
    curs: [
      {
        platform: "all",
        curr: "USD",
        price: "19.99",
        currLocked: true,
        add: true
      }
    ],
    platformsEnabled: false,
    platformsAdded: false,
    uploaded: false,
    platforms: [
      {
        id: "steam",
        name: "Steam",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ],
        prices: [
          {
            id: 'USD',
            price: null,
            default: true,
          },
          {
            id: 'EUR',
            price: null,
            default: false,
          },
          {
            id: 'RUB',
            price: null,
            default: false,
          },
        ],
      },
      {
        id: "gog",
        name: "GOG",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        prices: [
          {
            id: 'USD',
            price: null,
            default: true,
          },
          {
            id: 'EUR',
            price: null,
            default: false,
          },
          {
            id: 'RUB',
            price: null,
            default: false,
          },
        ],
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "epic",
        name: "Epic Games Store",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        prices: [
          {
            id: 'USD',
            price: null,
            default: true,
          },
          {
            id: 'EUR',
            price: null,
            default: false,
          },
          {
            id: 'RUB',
            price: null,
            default: false,
          },
        ],
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "drmfree",
        name: "DRM-Free",
        distr: "drmfree",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        prices: [
          {
            id: 'USD',
            price: null,
            default: true,
          },
          {
            id: 'EUR',
            price: null,
            default: false,
          },
          {
            id: 'RUB',
            price: null,
            default: false,
          },
        ],
        os: [
          {
            id: "windows",
            name: "Windows",
            value: false,
            files: [
              { id: "file1", name: "mygame_distributive_win.exe", value: false }
            ]
          },
          {
            id: "mac",
            name: "Mac",
            value: false,
            files: [
              { id: "file2", name: "mygame_distributive_mac.dmg", value: false }
            ]
          },
          {
            id: "linux",
            name: "Linux",
            value: false,
            files: [
              {
                id: "file3",
                name: "mygame_distributive_play.apk",
                value: false
              }
            ]
          }
        ]
      },
      {
        id: "ps4",
        name: "PlayStation",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "Versions",
        prices: [
          {
            id: 'USD',
            price: null,
            default: true,
          },
          {
            id: 'EUR',
            price: null,
            default: false,
          },
          {
            id: 'RUB',
            price: null,
            default: false,
          },
        ],
        os: [
          { id: "ps4", name: "PS4", value: false },
          { id: "ps3", name: "PS3", value: false }
        ]
      },
      {
        id: "xbox1",
        name: "XBOX",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "Versions",
        prices: [
          {
            id: 'USD',
            price: null,
            default: true,
          },
          {
            id: 'EUR',
            price: null,
            default: false,
          },
          {
            id: 'RUB',
            price: null,
            default: false,
          },
        ],
        os: [
          { id: "xbox1", name: "Xbox One", value: false },
          { id: "xbox360", name: "Xbox 360", value: false }
        ]
      },
      {
        id: "nintendo",
        name: "Nintendo Switch eShop",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "Versions",
        prices: [
          {
            id: 'USD',
            price: null,
            default: true,
          },
          {
            id: 'EUR',
            price: null,
            default: false,
          },
          {
            id: 'RUB',
            price: null,
            default: false,
          },
        ],
        os: [
          // { id: "switch", name: "Nintendo Switch", value: false },
          // { id: "ds3ds2", name: "Nintendo 3DS/2DS", value: false }
        ]
      }
    ]
  }
};

export const blankKeyOld = {
  sku: "my_project",
  storeGK: "not ready",
  keyData: {
    general: {
      sku: {
        value: "my_project",
        shown: false
      },
      name: {
        value: "My Project",
        languages: false,
        content: ["My Project", "Мой проект", "Mon projet"]
      }
    },
    buyPre: {
      value: "buy", //pre
      when: "exact"
    },
    delivery: {
      value: "xsolla"
    },
    curs: [
      {
        platform: "all",
        curr: "USD",
        price: "19.99",
        currLocked: true,
        add: true
      }
    ],
    platformsEnabled: false,
    platformsAdded: false,
    uploaded: false,
    platforms: [
      {
        id: "steam",
        name: "Steam",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "gog",
        name: "GOG",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "epic",
        name: "Epic Games Store",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "windows",
        name: "Windows DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      },
      {
        id: "mac",
        name: "Mac OS DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      },
      {
        id: "drmfree",
        name: "DRM-Free Keys",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "ps4",
        name: "PlayStation",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "Versions",
        os: [
          { id: "ps4", name: "PS4", value: false },
          { id: "ps3", name: "PS3", value: false }
        ]
      },
      {
        id: "xbox1",
        name: "XBOX",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "Versions",
        os: [
          { id: "xbox1", name: "Xbox One", value: false },
          { id: "xbox360", name: "Xbox 360", value: false }
        ]
      },
      {
        id: "nintendo",
        name: "Nintendo Switch eShop",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "Versions",
        os: [
          // { id: "switch", name: "Nintendo Switch", value: false },
          // { id: "ds3ds2", name: "Nintendo 3DS/2DS", value: false }
        ]
      },
      {
        id: "linux",
        name: "Linux DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      }
    ]
  }
};

export const blankKeyFilled = {
  sku: "my_project_filled",
  storeGK: "ready",
  keyData: {
    general: {
      sku: {
        value: "steel_warriors_123123",
        shown: false
      },
      name: {
        value: "Steel Warriors 2",
        languages: false,
        content: ["My Project", "Мой проект", "Mon projet"]
      }
    },
    buyPre: {
      value: "buy", //pre
      when: "exact"
    },
    delivery: {
      value: "xsolla"
    },
    curs: [
      {
        platform: "all",
        curr: "USD",
        price: "19.99",
        currLocked: true,
        add: true
      }
    ],
    platformsEnabled: true,
    platformsAdded: true,
    uploaded: true,
    platforms: [
      {
        id: "steam",
        name: "Steam",
        distr: "keys",
        added: true,
        uploaded: true,
        enabled: true,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: true },
          { id: "mac", name: "Mac", value: true },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "gog",
        name: "GOG",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "epic",
        name: "Epic Games Store",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "windows",
        name: "Windows DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      },
      {
        id: "mac",
        name: "Mac OS DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      },
      {
        id: "drmfree",
        name: "DRM-Free Keys",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "ps4",
        name: "PlayStation",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "ps4", name: "PS4", value: false },
          { id: "ps3", name: "PS3", value: false }
        ]
      },
      {
        id: "xbox1",
        name: "XBOX",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "xbox1", name: "Xbox One", value: false },
          { id: "xbox360", name: "Xbox 360", value: false }
        ]
      },
      {
        id: "nintendo",
        name: "Nintendo",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "switch", name: "Nintendo Switch", value: false },
          { id: "ds3ds2", name: "Nintendo 3DS/2DS", value: false }
        ]
      },
      {
        id: "linux",
        name: "Linux DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      }
    ]
  }
};

export const blankKeyFilled2 = {
  sku: "my_project_filled2",
  storeGK: "ready",
  keyData: {
    general: {
      sku: {
        value: "steel_warriors_2",
        shown: false
      },
      name: {
        value: "Steel Warriors Ultimate",
        languages: false,
        content: ["My Project", "Мой проект", "Mon projet"]
      }
    },
    buyPre: {
      value: "buy", //pre
      when: "exact"
    },
    delivery: {
      value: "xsolla"
    },
    curs: [
      {
        platform: "all",
        curr: "USD",
        price: "19.99",
        currLocked: true,
        add: true
      }
    ],
    platformsEnabled: true,
    platformsAdded: true,
    uploaded: true,
    platforms: [
      {
        id: "steam",
        name: "Steam",
        distr: "keys",
        added: true,
        uploaded: true,
        enabled: true,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: true },
          { id: "mac", name: "Mac", value: true },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "gog",
        name: "GOG",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "epic",
        name: "Epic Games Store",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "windows",
        name: "Windows DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      },
      {
        id: "mac",
        name: "Mac OS DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      },
      {
        id: "drmfree",
        name: "DRM-Free Keys",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "windows", name: "Windows", value: false },
          { id: "mac", name: "Mac", value: false },
          { id: "linux", name: "Linux", value: false }
        ]
      },
      {
        id: "ps4",
        name: "PlayStation",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "ps4", name: "PS4", value: false },
          { id: "ps3", name: "PS3", value: false }
        ]
      },
      {
        id: "xbox1",
        name: "XBOX",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "xbox1", name: "Xbox One", value: false },
          { id: "xbox360", name: "Xbox 360", value: false }
        ]
      },
      {
        id: "nintendo",
        name: "Nintendo",
        distr: "keys",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [
          { id: "switch", name: "Nintendo Switch", value: false },
          { id: "ds3ds2", name: "Nintendo 3DS/2DS", value: false }
        ]
      },
      {
        id: "linux",
        name: "Linux DRM-Free",
        distr: "distr",
        added: false,
        uploaded: false,
        enabled: false,
        osName: "OS",
        os: [],
        files: [
          { id: "file1", name: "mygame_distributive_win.exe", value: false },
          { id: "file2", name: "mygame_distributive_mac.dmg", value: false },
          { id: "file3", name: "mygame_distributive_play.apk", value: false }
        ]
      }
    ]
  }
};

export const platforms = {};

export const defaultWidget = {
  type: "square",
  colorBg: "black",
  colorTxt: "white",
  colorBut: "green",
  colorButTxt: "white",
  theme: "light"
};
